module.exports = __webpack_public_path__ + "img/login_background.a8e45e12.png";